'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _require = require('lodash'),
    cloneDeep = _require.cloneDeep,
    isNil = _require.isNil;

var _require2 = require('../../constants/actionTypes'),
    TRANSFER = _require2.TRANSFER;

var _require3 = require('../../constants/jobTriggerTypes'),
    HotFolder = _require3.HotFolder;

var _require4 = require('./storageProfileMapper'),
    mapStorageProfile = _require4.mapStorageProfile;

var _require5 = require('./folderMonitorMapper'),
    mapFolderMonitor = _require5.mapFolderMonitor;

var mapAction = function mapAction(_ref) {
    var userAccountId = _ref.userAccountId,
        jobAccountId = _ref.jobAccountId;
    return function (action) {
        if (action.type === TRANSFER) {
            var clonedAction = cloneDeep(action);
            var source = clonedAction.data.source;
            var destination = clonedAction.data.destination;
            var storageProfileMapper = mapStorageProfile(userAccountId);
            var mappedSource = storageProfileMapper(source);
            var mappedDestination = storageProfileMapper(destination);

            clonedAction.data.source = mappedSource;
            clonedAction.data.destination = mappedDestination;

            return removePartnerActionAttributes(userAccountId, jobAccountId, clonedAction);
        }
        return action;
    };
};

var mapTrigger = function mapTrigger(userAccountId) {
    return function (trigger) {
        if (trigger.type === HotFolder) {
            var clonedTrigger = cloneDeep(trigger);
            clonedTrigger.data.source = mapStorageProfile(userAccountId)(clonedTrigger.data.source);
            if (!isNil(clonedTrigger.monitor)) {
                clonedTrigger.monitor = mapFolderMonitor(userAccountId)(clonedTrigger.monitor);
            }

            return clonedTrigger;
        }
        return trigger;
    };
};
var removePartnerJobAttributes = function removePartnerJobAttributes(userAccountId, _ref2) {
    var accountId = _ref2.accountId,
        createdBy = _ref2.createdBy,
        createdByAuthId = _ref2.createdByAuthId,
        lastModifiedBy = _ref2.lastModifiedBy,
        lastModifiedByAuthId = _ref2.lastModifiedByAuthId,
        rest = _objectWithoutProperties(_ref2, ['accountId', 'createdBy', 'createdByAuthId', 'lastModifiedBy', 'lastModifiedByAuthId']);

    var returningJob = _extends({ accountId: accountId }, rest);
    //Owner of the job can see all attributes but partner will not see user details
    if (userAccountId === accountId) {
        returningJob = _extends({}, returningJob, {
            createdBy: createdBy,
            createdByAuthId: createdByAuthId,
            lastModifiedBy: lastModifiedBy,
            lastModifiedByAuthId: lastModifiedByAuthId
        });
    }
    return returningJob;
};

var removePartnerActionAttributes = function removePartnerActionAttributes(userAccountId, jobAccountId, _ref3) {
    var postTransfer = _ref3.postTransfer,
        restOfAction = _objectWithoutProperties(_ref3, ['postTransfer']);

    var returningAction = restOfAction;
    //Owner of the job can see all attributes but partner will not see private attributes
    if (userAccountId === jobAccountId) {
        returningAction = _extends({}, returningAction, {
            postTransfer: postTransfer
        });
    }
    return returningAction;
};

var applyJobsACL = function applyJobsACL(accountId) {
    return function (job) {
        var clonedJob = cloneDeep(job);
        var mappedActions = clonedJob.actions.map(mapAction({ userAccountId: accountId, jobAccountId: job.accountId }));
        var mappedTriggers = clonedJob.triggers.map(mapTrigger(accountId));
        var returnedJob = _extends({}, removePartnerJobAttributes(accountId, clonedJob), {
            actions: mappedActions,
            triggers: mappedTriggers
        });
        return returnedJob;
    };
};

module.exports = {
    applyJobsACL: applyJobsACL,
    removePartnerActionAttributes: removePartnerActionAttributes
};